import React from "react";
import PropTypes from "prop-types";
import { Form } from "@domestika-dev/prudencio/dist/atoms/Form";
import { useIntl } from "react-intl";

import { errorsMessagesUploaderImageMultiple } from "../utils";

export const MultiUploader = ({
  isImageLoading,
  validateForm,
  onImagesLoad,
  maxNumFiles,
  maxUploadSizeMessage,
  descriptionMessage,
  progressMessage,
}) => {
  const intl = useIntl();

  return (
    <Form.Field
      size="small"
      label={intl.formatMessage({ id: "projects.new.more_content_section.title_add_organize" })}
      id="ContentItemMenu"
      required
    >
      <Form.Uploader
        name="contentItemUploaderMultiple"
        multiple
        maxNumFiles={maxNumFiles}
        size="large"
        validate={validateForm}
        onImagesLoad={onImagesLoad}
        loading={isImageLoading}
        progressNumber={80}
        errors={errorsMessagesUploaderImageMultiple}
        maxUploadSizeMessage={maxUploadSizeMessage}
        descriptionMessage={descriptionMessage}
        progressMessage={progressMessage}
      />
    </Form.Field>
  );
};

MultiUploader.propTypes = {
  isImageLoading: PropTypes.bool,
  validateForm: PropTypes.func,
  onImagesLoad: PropTypes.func,
  maxNumFiles: PropTypes.number,
  maxUploadSizeMessage: PropTypes.string,
  descriptionMessage: PropTypes.string,
  progressMessage: PropTypes.string,
};

MultiUploader.defaultProps = {
  isImageLoading: false,
  validateForm: () => {},
  onImagesLoad: () => {},
  maxNumFiles: 15,
  maxUploadSizeMessage: "",
  descriptionMessage: "",
  progressMessage: "",
};

export default MultiUploader;
